import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { RiToolsLine } from '@remixicon/react';
import { rootRouteRef } from './routes';

const maintenanceDashboardPage = PageBlueprint.make({
  params: {
    path: '/maintenance-dashboard',
    routeRef: rootRouteRef,
    title: 'Maintenance',
    // The page renders its own `Page`/`Header` and tab bar.
    noHeader: true,
    loader: () =>
      import(
        './components/MaintenanceDashboardPage/MaintenanceDashboardPage'
      ).then(m => <m.MaintenanceDashboardPage />),
  },
});

export const maintenanceDashboardPlugin = createFrontendPlugin({
  pluginId: 'maintenance-dashboard',
  title: 'Maintenance',
  icon: <RiToolsLine />,
  routes: {
    root: rootRouteRef,
  },
  extensions: [maintenanceDashboardPage],
});
